// these error codes should match the server-side
export const ERROR_APPLICATION = "ERROR_APPLICATION";
export const ERROR_ACCESS_DENIED = "ERROR_ACCESS_DENIED";
export const ERROR_NO_RECORD_FOUND = "ERROR_NO_RECORD_FOUND";
export const ERROR_NO_ROWS_UPDATED = "ERROR_NO_ROWS_UPDATED";
export const VALIDATION_DEVELOPER_ALREADY_HAS_ACCESS = "VALIDATION_DEVELOPER_ALREADY_HAS_ACCESS";
